import { h, Component } from 'preact';
import { Router } from 'preact-router';

// Code-splitting is automated for routes
import Podcast from '../routes/podcast';
import Intro from '../routes/intro';

export default class App extends Component {
	
	/** Gets fired when the route changes.
	 *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
	 *	@param {string} event.url	The newly routed URL
	 */
	handleRoute = e => {
		this.currentUrl = e.url;
	};

	render() {
		return (
			<div id="app">
				<Router onChange={this.handleRoute}>
					<Intro path="/" />
					<Podcast path="/podcast" />
				</Router>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/app.js